import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import useAmbassador from "containers/ambassador/useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noPointsFound from "assets/images/gifs/points-not-found.gif";
import { useSelector } from "react-redux";

const PrizePoints = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState<any>([])
  const [hasFetched, setHasFetched] = useState(false);
  const { getAmbassadorProducts } = useAmbassador()
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  useEffect(() => {
    getAmbassadorProducts(setData)
  }, [])

  // Mark initial load as complete when loading finishes
  useEffect(() => {
    if (!hasFetched && !isLoading) {
      setHasFetched(true);
    }
  }, [isLoading, hasFetched]);
  
  return (
    <div>
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-blackie mb-6">
          Prize Points
        </h2>
      </div>

      {data?.products && data?.products?.length > 0 ? (
        data?.products?.map((item:any, index:number) => (
          <div
            key={index}
            className="flex justify-between items-center bordr-linear py-3"
          >
            <div className="flex items-center gap-3">
            <img src={concatPathWithBackendUrl(item?.image?.name)} alt="" className="w-12 h-12"/>
            <p className="text-lg font-semibold text-primaryBlueText">
              {item.itemName}:
            </p>
            </div>
            <p className="text-ambassadorBlue text-lg font-semibold">
              {item.cost}{'.0'} pts
            </p>
          </div>
        ))
      ) : (
        <CustomMessageDisplay
          show={hasFetched && !isLoading && (!data?.products || data?.products?.length === 0)}
          title="No Prize Points Available"
          slogan="No prize points are available at the moment. Check back later for new rewards!"
          image={noPointsFound}
          imageAlt="No prize points found"
          className="py-12"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      )}
    </div>
  );
};

export default PrizePoints;
